import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `index.lazy.tsx` so the
// destinations bundle (forms, sheet, schema validation) loads on demand.
export const Route = createFileRoute("/app/destinations/")({});
